import { useState, useEffect } from "react";
import "./css/cancelactionmodal.css";

const CancelActionModal = ({ isAccept, selectedItems, onClose, onConfirm }) => {
  /* ── 승인: 항상 표시되는 사유 입력 ── */
  const [reasons, setReasons] = useState(() =>
    Object.fromEntries(selectedItems.map((item) => [item.orderDetailIdx, ""]))
  );

  /* ── 거절: 드롭다운 상태 ── */
  const [openDropdowns, setOpenDropdowns] = useState(() =>
    Object.fromEntries(selectedItems.map((item) => [item.orderDetailIdx, false]))
  );
  const [draftReasons, setDraftReasons] = useState(() =>
    Object.fromEntries(selectedItems.map((item) => [item.orderDetailIdx, ""]))
  );
  const [savedReasons, setSavedReasons] = useState(() =>
    Object.fromEntries(selectedItems.map((item) => [item.orderDetailIdx, ""]))
  );

  const [showConfirm, setShowConfirm] = useState(false);

  /* 모달 열린 동안 body 스크롤 잠금 */
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  const setReason = (idx, value) =>
    setReasons((prev) => ({ ...prev, [idx]: value }));

  const toggleDropdown = (idx) =>
    setOpenDropdowns((prev) => ({ ...prev, [idx]: !prev[idx] }));

  const saveDraft = (idx) => {
    if (draftReasons[idx].trim().length > 0) {
      setSavedReasons((prev) => ({ ...prev, [idx]: draftReasons[idx] }));
    }
    setOpenDropdowns((prev) => ({ ...prev, [idx]: false }));
  };

  const cancelDraft = (idx) => {
    setDraftReasons((prev) => ({ ...prev, [idx]: savedReasons[idx] }));
    setOpenDropdowns((prev) => ({ ...prev, [idx]: false }));
  };

  const handleConfirm = () => {
    onConfirm(isAccept ? reasons : savedReasons);
  };

  const metaPills = (item) => (
    <div className="cancelactionmodal-card-meta">
      <span className="cancelactionmodal-meta-item">
        <span className="cancelactionmodal-meta-label">수량</span>
        {item.quantity}개
      </span>
      <span className="cancelactionmodal-meta-divider" />
      <span className="cancelactionmodal-meta-item">
        <span className="cancelactionmodal-meta-label">가격</span>
        {item.price?.toLocaleString()}원
      </span>
      <span className="cancelactionmodal-meta-divider" />
      <span className="cancelactionmodal-meta-item">
        <span className="cancelactionmodal-meta-label">구매자</span>
        {item.custName}
      </span>
      <span className="cancelactionmodal-meta-divider" />
      <span className="cancelactionmodal-meta-item">
        <span className="cancelactionmodal-meta-label">연락처</span>
        {item.custPhone}
      </span>
    </div>
  );


  return (
    <>
      {/* ── 메인 모달 ── */}
      <div className="cancelactionmodal-wrap">
        <div className="cancelactionmodal" onClick={(e) => e.stopPropagation()}>
          <button className="cancelactionmodal-close" onClick={onClose}>✕</button>

          <div className="cancelactionmodal-header">
            <span className={`cancelactionmodal-header-badge ${isAccept ? "approve" : "reject"}`}>
              {isAccept ? "승인" : "거절"}
            </span>
            처리 확인
            <span className="cancelactionmodal-count" style={{ marginLeft: 6 }}>{selectedItems.length}건</span>
          </div>

          {/* 항목별 상세 */}
          <div className="cancelactionmodal-items-scroll">
            {selectedItems.map((item, idx) => {
              const key = item.orderDetailIdx;

              /* ── 승인: 현재 상태 유지 ── */
              if (isAccept) {
                return (
                  <div key={key} className="cancelactionmodal-item-block">
                    <div className="cancelactionmodal-item-row">
                      <div className="cancelactionmodal-card">
                        <div className="cancelactionmodal-card-main">
                          <div className="cancelactionmodal-item-index">{idx + 1}</div>
                          <span className="cancelactionmodal-product-name">{item.productName}</span>
                          <span className="cancelactionmodal-order-code">{item.orderCode}</span>
                        </div>
                        {metaPills(item)}
                      </div>
                    </div>
                    <div className="cancelactionmodal-reason-area">
                      <div className="cancelactionmodal-reason-label">
                        사유
                        <span className="cancelactionmodal-optional">선택</span>
                      </div>
                      <textarea
                        className="cancelactionmodal-textarea"
                        placeholder="사유를 입력해주세요."
                        value={reasons[key]}
                        onChange={(e) => setReason(key, e.target.value)}
                        maxLength={500}
                      />
                      <div className="cancelactionmodal-help">💬 입력한 내용은 고객에게 안내되는 문구입니다.</div>
                      <div className="cancelactionmodal-charcount">{reasons[key].length} / 500</div>
                    </div>
                  </div>
                );
              }

              /* ── 거절: 드롭다운 사유 입력 ── */
              const isOpen = openDropdowns[key];
              const draft = draftReasons[key];
              const hasSaved = savedReasons[key]?.trim().length > 0;

              return (
                <div key={key} className="cancelactionmodal-item-block">
                  <div className={`cancelactionmodal-card${hasSaved ? " has-reason" : ""}`}>
                    <div className="cancelactionmodal-card-top">
                      <div className="cancelactionmodal-card-main">
                        <div className="cancelactionmodal-item-index">{idx + 1}</div>
                        <span className="cancelactionmodal-product-name">{item.productName}</span>
                        <span className="cancelactionmodal-order-code">{item.orderCode}</span>
                      </div>
                      <button
                        className={`cancelactionmodal-reason-toggle-btn${hasSaved ? " saved" : ""}${isOpen ? " active" : ""}`}
                        onClick={() => toggleDropdown(key)}
                      >
                        {hasSaved ? "사유 수정" : "사유 입력"}
                        <span className="cancelactionmodal-toggle-arrow">{isOpen ? "▲" : "▼"}</span>
                      </button>
                    </div>
                    <div className="cancelactionmodal-card-bottom">
                      {metaPills(item)}
                      {hasSaved && (
                        <div className="cancelactionmodal-reason-saved-indicator">
                          ✓ 사유 등록됨
                        </div>
                      )}
                    </div>
                  </div>

                  {/* 드롭다운 */}
                  <div className={`cancelactionmodal-reason-dropdown${isOpen ? " open" : ""}`}>
                    <div className="cancelactionmodal-reason-dropdown-inner">
                      <textarea
                        className="cancelactionmodal-textarea"
                        placeholder="📝 입력한 사유는 거절에 대한 내부 메모로 저장됩니다."
                        value={draft}
                        onChange={(e) =>
                          setDraftReasons((prev) => ({ ...prev, [key]: e.target.value }))
                        }
                        maxLength={500}
                      />
                      <div className="cancelactionmodal-dropdown-save-area">
                        <span className="cancelactionmodal-charcount-inline">{draft.length} / 500</span>
                        <div className="cancelactionmodal-dropdown-btns">
                          <button
                            className="cancelactionmodal-btn reject small"
                            onClick={() => saveDraft(key)}
                          >
                            저장
                          </button>
                          <button
                            className="cancelactionmodal-btn outline small"
                            onClick={() => cancelDraft(key)}
                          >
                            취소
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="cancelactionmodal-footer">
            <button
              className={`cancelactionmodal-btn ${isAccept ? "approve" : "reject"}`}
              onClick={() => setShowConfirm(true)}
            >
              확인
            </button>
            <button className="cancelactionmodal-btn outline" onClick={onClose}>취소</button>
          </div>
        </div>
      </div>

      {/* ── 2차 확인 모달 ── */}
      {showConfirm && (
        <div className="cancelactionmodal-confirm-wrap">
          <div className="cancelactionmodal-confirm">
            <div className="cancelactionmodal-confirm-icon">⚠️</div>
            <div className="cancelactionmodal-confirm-title">
              {selectedItems.length}건을 {isAccept ? "승인" : "거절"} 처리하시겠습니까?
            </div>
            <div className="cancelactionmodal-confirm-desc">
              한번 확정된 내용은 변경이 어려울 수 있습니다.<br />
              내용을 다시 한번 확인 후 진행해주세요.
            </div>
            <div className="cancelactionmodal-confirm-actions">
              <button
                className={`cancelactionmodal-btn ${isAccept ? "approve" : "reject"}`}
                onClick={handleConfirm}
              >
                {isAccept ? "승인" : "거절"} 확정
              </button>
              <button
                className="cancelactionmodal-btn outline"
                onClick={() => setShowConfirm(false)}
              >
                돌아가기
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CancelActionModal;

